import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

// Reemplaza los alert()/confirm() nativos del navegador (feos, bloquean la
// página y no van con el estilo del sitio) por un mensajito propio que
// aparece arriba de todo y se cierra solo. Usar así:
//   const { showToast } = useToast();
//   showToast("Listo, se guardó todo.", "success");
const ToastContext = createContext(null);

let idCounter = 0;

export const ToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);
    const timers = useRef({});

    const removeToast = useCallback((id) => {
        setToasts(prev => prev.filter(t => t.id !== id));
        if (timers.current[id]) {
            clearTimeout(timers.current[id]);
            delete timers.current[id];
        }
    }, []);

    const showToast = useCallback((message, type = 'info', duration = 4500) => {
        const id = ++idCounter;
        setToasts(prev => [...prev, { id, message, type }]);
        timers.current[id] = setTimeout(() => removeToast(id), duration);
    }, [removeToast]);

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            <div className="toast-container">
                {toasts.map(t => (
                    <div
                        key={t.id}
                        className={`toast toast-${t.type}`}
                        onClick={() => removeToast(t.id)}
                    >
                        {t.message}
                    </div>
                ))}
            </div>
        </ToastContext.Provider>
    );
};

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToast debe usarse dentro de un <ToastProvider>.');
    }
    return context;
};
